import { render, staticRenderFns } from "./branches.vue?vue&type=template&id=56cb13f7&scoped=true&"
import script from "./branches.vue?vue&type=script&lang=ts&"
export * from "./branches.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cb13f7",
  null
  
)

export default component.exports